import "./row.scss";

import { PureComponent } from "react";
import PropTypes from "prop-types";

import RowTitle from "common/document/uploader/manager/row_title";
import { ProcessingStates } from "graphql_globals";
import { QUEUED, UPLOADING, SUCCESS, FAILED } from "common/document/uploader/add_modal/upload_view";

import { DOCUMENT_MIMETYPES } from "../uploader/document_item_util";

const UPLOAD_DOCUMENT_PROPTYPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  status: PropTypes.oneOf([QUEUED, FAILED, SUCCESS, UPLOADING]),
});

class MultiUploadRow extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      editingTitleValue: null,
    };
  }

  handleDeleteDocument = () => {
    const { document, onDeleteDocument } = this.props;
    onDeleteDocument(document);
  };

  handleStartRenameDocument = () => {
    const { document, onStartRenameDocument } = this.props;
    const { name } = document;
    const lastIndex = name.lastIndexOf(".") > 0 ? name.lastIndexOf(".") : name.length;
    const newEditingTitleValue = name.slice(0, lastIndex);
    this.setState(() => ({
      editingTitleValue: newEditingTitleValue,
    }));
    onStartRenameDocument(document);
  };

  handleStopRenameDocument = () => {
    const { editingTitleValue } = this.state;
    const { document, onStopRenameDocument } = this.props;
    this.setState(() => ({ editingTitleValue: null }));
    onStopRenameDocument(document, editingTitleValue);
  };

  handleChangeDocumentTitle = ({ target: { value } }) => {
    this.setState(() => ({ editingTitleValue: value }));
  };

  determineProcessingStateFromStatus = (status) => {
    if (status === UPLOADING || status === QUEUED) {
      return ProcessingStates.PENDING;
    }
    if (status === FAILED) {
      return ProcessingStates.FAILED;
    }
    return ProcessingStates.DONE;
  };

  render() {
    const { document, documentIndex } = this.props;
    const mimeType = DOCUMENT_MIMETYPES.ANY;
    const { editingTitleValue } = this.state;
    const { name, status } = document;
    const processingState = this.determineProcessingStateFromStatus(status);

    return (
      <li className="MultiUploaderRow" data-document-id={document.id}>
        <RowTitle
          name={name}
          index={documentIndex}
          status={processingState}
          mimeType={mimeType}
          workingTitle={editingTitleValue}
          onDeleteDocument={this.handleDeleteDocument}
          onStartRename={this.handleStartRenameDocument}
          onStopRename={this.handleStopRenameDocument}
          onChangeTitle={this.handleChangeDocumentTitle}
          onResubmitDocument={() => {}}
          cxName="MultiRowTitle"
          disableClick
          allowRename
          allowDelete
          allowDeleteOnRename
        />
      </li>
    );
  }
}

MultiUploadRow.propTypes = {
  documentIndex: PropTypes.number.isRequired,
  document: UPLOAD_DOCUMENT_PROPTYPE.isRequired,
  /** Called with document object deleted */
  onDeleteDocument: PropTypes.func.isRequired,
  /** Called with document object user has requested rename of */
  onStartRenameDocument: PropTypes.func.isRequired,
  /** Called with document object when user finished renaming */
  onStopRenameDocument: PropTypes.func.isRequired,
};

MultiUploadRow.defaultProps = {
  onStartRenameDocument: () => {},
  onStopRenameDocument: () => {},
};

export default MultiUploadRow;
